const gridToggle = () => {
  let toggleControls = document.querySelectorAll('.btn-grid-control');

  const removeActiveClass = (el) => {
    let controls = el.querySelectorAll('.btn-grid-control');

    controls.forEach(control => {
      control.classList.remove('active');
    });
  };

  if (toggleControls.length > 0) {
    let gridClasses = [];

    toggleControls.forEach(toggleControl => {
      gridClasses.push(toggleControl.dataset.gridStyle);

      toggleControl.addEventListener('click', () => {
        let targets = document.querySelectorAll(toggleControls[0].dataset.target);

        removeActiveClass(toggleControl.parentElement);

        targets.forEach(function (target) {
          target.classList.remove(...gridClasses);
          target.classList.add(toggleControl.dataset.gridStyle);
        });

        toggleControl.classList.add('active');
      });
    });
  }
};

export default gridToggle;



// WEBPACK FOOTER //
// ./scripts/grid-toggle.js